/* eslint-disable */
import { THEME_PALETTE_TYPE_LIGHT } from '../../../Constants/Theme/Theme.constants';
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';

/**
 * Determine if a given `type` is a `light`
 * @export
 * @param {any} type The 'type' to check
 * @returns {boolean} Whether or not `type` is indeed `light`
 */
const themeIsLight = (type = throwParameterRequiredError(`type`)) => type === THEME_PALETTE_TYPE_LIGHT;

export default themeIsLight;
